module.exports = __webpack_public_path__ + "img/visa.d4eabf6f.png";